import Box, { BoxProps } from "@material-ui/core/Box";
// import { ReactComponent as LogoSvg } from "../assets/logo.svg";
// import LogoImg from '../../assets/img/Tavant.png';
import Typography from "@material-ui/core/Typography";


type LogoProps = {
  colored?: boolean;
  size?: number;
  display?:string
} & BoxProps;

const Logo = ({ colored = false, size = 40,display, ...boxProps }: LogoProps) => {
  return (
    <Box {...boxProps} justifyContent="center">
      <Typography variant="h1" component="h1" sx={{fontSize:30,mt:"22px",mb:"22px"}}>TMAP</Typography>
      {/* <LogoSvg height={size} width={size} /> */}
      {/* <img src={LogoImg} alt="Logo" width="100%"/> */}
    </Box>
  );
};

export default Logo;
